import * as React from 'react';
import { styled } from '@mui/material';
import { Row } from 'library/ui';
import Image from 'assets/images/LoginSignUpImage.jpg';
import theme from 'theme';

export default function SignUpLoginContainer({ children }: { children: React.ReactNode }) {
    return (
        <Container align="stretch">
            <FormColumn>{children}</FormColumn>
            <ImageColumn>
                <StyledImage src={Image} alt="Customer testimonial" />
            </ImageColumn>
        </Container>
    );
}

const Container = styled(Row)({
    height: '95vh',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
        height: 'auto',
        overflow: 'visible',
    },
});

const FormColumn = styled('div')({
    flex: 1,
    minWidth: 0,
    overflowY: 'auto',
    maxHeight: '100%',
    padding: 32,
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
        overflowY: 'visible',
        maxHeight: 'none',
        padding: 20,
    },
});

const ImageColumn = styled('div')({
    flex: 1,
    height: '100vh',
    zIndex: -1,
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
});

const StyledImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
});
